import { cn } from '../../lib/utils';
import React, { AnchorHTMLAttributes } from 'react';
import { NavLink, Link as NormalLink, useLocation } from 'react-router-dom';
import { AnchorIcon } from './Icon';
import { routeUrls } from '../../routes';

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
    hideAnchorIcon?: boolean;
} &  React.HTMLAttributes<"button">;

const linkClassName = 'group flex gap-3 items-center text-primary text-base';
const isActiveClassName = 'underline underline-offset-8 decoration-active decoration-2';

export const RouterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(({ hideAnchorIcon, href, children, className, ...props }, ref) => {
    const location = useLocation();

    // This is a solution for the fact that the NavLink component doesn't add the active class to the link when the route is '/'
    const getActiveClass = (isActive: boolean) => {
        const linkIsActive = (location.pathname === '/' && href === routeUrls.DASHBOARD) || isActive;

        return linkIsActive ? isActiveClassName : '';
    };

    return (
        <NavLink
            to={href || '/'}
            className={({ isActive }) => cn(`${linkClassName} ${getActiveClass(isActive)}`, className)}
            ref={ref}
            aria-label={'link that navigates to ' + href}
            {...props}
        >
            {!hideAnchorIcon && <AnchorIcon />}

            {children}
        </NavLink>
    );
});

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(({ hideAnchorIcon, href, children, className, ...props }, ref) => {
    return (
        <NormalLink to={href || '/'} className={cn(linkClassName, className)} ref={ref} aria-label={'link that navigates to ' + href} {...props}>
            {!hideAnchorIcon && <AnchorIcon />}

            {children}
        </NormalLink>
    );
});
